import { Box, InputLabel, Typography } from "@mui/material";
import PropTypes from "prop-types";

function StringForm({ label, text, action = undefined, ...props }) {
  return (
    <Box
      sx={{
        pb: 0.5,
        pt: { xs: 0, md: 0.5 },
      }}
      {...props}
    >
      <InputLabel
        sx={{
          fontWeight: 600,
          color: "text.primary",
          fontSize: "1rem",
          mb: 0.5,
        }}
      >
        {label}
      </InputLabel>
      {typeof text === "string" ? (
        <Typography variant="body2" sx={{ mt: -0.25, display: "block", mb: action ? 1 : 0 }}>
          {text}
        </Typography>
      ) : (
        text
      )}
      {action}
    </Box>
  );
}

StringForm.propTypes = {
  label: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  action: PropTypes.node,
};

export default StringForm;
